import { Chip, Theme, withStyles, Tooltip } from '@material-ui/core';
import { PublishStatus,ServicePublishStatus } from '@lib/company';
import { ComponentProps } from 'react';
import { green, amber, grey, deepOrange, red, blue, indigo, teal } from '@material-ui/core/colors';
import { generateChipColor } from '@lib/common';
import {
  BsFillGearFill,
  AiFillCheckCircle,
  AiFillStop,
  AiOutlineCheckCircle,
  MdCheckCircle,
  FaCheckCircle,
  RiDraftFill,
  VscMultipleWindows,
} from '@icon/react-icons';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import { ColoredChip } from './colored-elements';

type PublishStatusChipIconProps = ComponentProps<typeof Chip> & {
  status: PublishStatus | `${PublishStatus}`;
  iconOnly?: boolean;
  hideManual?: boolean;
};

type ServicePublishStatusChipIconProps = ComponentProps<typeof Chip> & {
  status: ServicePublishStatus | `${ServicePublishStatus}`;
  iconOnly?: boolean;
  hideManual?: boolean;
};
const statusMap = {
  'PS_-1': {
    color: red,
    icon: <AiFillStop style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_-1'],
  },
  PS_0: {
    color: red,
    icon: <AiFillStop style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_0'],
  },
  PS_1: {
    color: green,
    icon: <MdCheckCircle style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_1'],
  },
  PS_2: {
    color: green,
    icon: <FaCheckCircle style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_2'],
  },
  PS_3: {
    color: deepOrange,
    icon: <VscMultipleWindows style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_3'],
  },
  'PS_-2': {
    color: teal,
    icon: <RiDraftFill style={{ color: 'inherit' }} />,
    label: PublishStatus['PS_-2'],
  },
};

const serviceStatusMap = {
  
  PS_0: {
    color: red,
    icon: <AiFillStop style={{ color: 'inherit' }} />,
    label: ServicePublishStatus['PS_0'],
  },
  PS_1: {
    color: green,
    icon: <MdCheckCircle style={{ color: 'inherit' }} />,
    label: ServicePublishStatus['PS_1'],
  },
  
};
const AutomaticPublish = {
  PS_0: {
    color: indigo,
    icon: <BsFillGearFill style={{ color: 'inherit' }} />,
    label: 'Auto',
  },
  PS_1: {
    color: indigo,
    icon: <BsFillGearFill style={{ color: 'inherit' }} />,
    label: 'Auto',
  },
  PS_3: {
    color: indigo,
    icon: <BsFillGearFill style={{ color: 'inherit' }} />,
    label: 'Auto',
  },
};

export const PublishStatusChip = withStyles<string, {}, PublishStatusChipIconProps>(
  (theme: Theme) => ({
    root: ({ status: type }) =>
      generateChipColor(theme, (statusMap[type] || { color: deepOrange }).color),
    label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  })
)(
  ({
    status: type,
    hideManual = false,
    children,
    iconOnly,
    size,
    ...props
  }: PublishStatusChipIconProps) => {
    const map = statusMap[type] || { label: 'Error!' };
    return (
      <>
        <Tooltip title={map.label}>
          <Chip icon={map.icon} label={iconOnly ? null : map.label} size={size} {...props} />
        </Tooltip>
        {!hideManual && type && ['PS_-1', 'PS_2'].indexOf(type) >= 0 && (
          <>
            &nbsp;
            <Tooltip title="Manual">
              <ColoredChip
                iconOnly={iconOnly}
                colored={amber[700]}
                icon={<AccountCircleRoundedIcon style={{ color: 'white' }} />}
                label={iconOnly ? null : 'Manual'}
                size={size}
              />
            </Tooltip>
          </>
        )}
      </>
    );
  }
);


export const ServicePublishStatusChip = withStyles<string, {}, ServicePublishStatusChipIconProps>(
  (theme: Theme) => ({
    root: ({ status: type }) =>
      generateChipColor(theme, (statusMap[type] || { color: deepOrange }).color),
    label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  })
)(
  ({
    status: type,
    hideManual = false,
    children,
    iconOnly,
    size,
    ...props
  }: ServicePublishStatusChipIconProps) => {
    const map = serviceStatusMap[type] || { label: 'Error!' };
    return (
      <>
        <Tooltip title={map.label}>
          <Chip icon={map.icon} label={iconOnly ? null : map.label} size={size} {...props} />
        </Tooltip>
        {!hideManual && type && ['PS_-1', 'PS_2'].indexOf(type) >= 0 && (
          <>
            &nbsp;
            <Tooltip title="Manual">
              <ColoredChip
                iconOnly={iconOnly}
                colored={amber[700]}
                icon={<AccountCircleRoundedIcon style={{ color: 'white' }} />}
                label={iconOnly ? null : 'Manual'}
                size={size}
              />
            </Tooltip>
          </>
        )}
      </>
    );
  }
);


export const PublishStatusAutoChip = withStyles<string, {}, PublishStatusChipIconProps>(
  (theme: Theme) => ({
    root: ({ status: type }) =>
      generateChipColor(theme, AutomaticPublish[type] ? AutomaticPublish[type].color : blue),
    label: ({ iconOnly }) => (iconOnly ? { paddingLeft: 0 } : {}),
  })
)(({ status: type, children, iconOnly, ...props }: PublishStatusChipIconProps) => {
  const autoStatus = AutomaticPublish[type];
  return (
    <>
      {autoStatus && (
        <>
          &nbsp;
          <Tooltip title={autoStatus.label}>
            <Chip icon={autoStatus.icon} label={iconOnly ? null : autoStatus.label} {...props} />
          </Tooltip>
        </>
      )}
    </>
  );
});
